import * as React from 'react';

interface IProps {
    className?: string;
}

class UseCaseTimeCommitmentDesktop extends React.Component<IProps> {
    public render() {
        return (
            <svg viewBox="0 0 350 416" fill="none" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
                <g clipPath="url(#useCaseTimeCommitment0)">
                    <rect y="0.852295" width="350" height="415" rx="30" fill="#031629" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M310.24 187.034C310.254 186.23 310.261 185.424 310.261 184.616C310.261 109.709 249.537 48.9854 174.631 48.9854C99.7239 48.9854 39 109.709 39 184.616C39 185.419 39.007 186.221 39.0209 187.02C40.3109 113.229 100.531 53.8076 174.63 53.8076C248.734 53.8076 308.957 113.237 310.24 187.034Z"
                        fill="url(#usecasetime_paint0_linear)"
                    />
                    <circle cx="174.629" cy="182.205" r="111.519" fill="#031629" />
                    <circle cx="174.632" cy="182.205" r="91.4485" stroke="white" strokeWidth="10" strokeDasharray="0.6 6.03" />
                </g>
                <defs>
                    <linearGradient id="usecasetime_paint0_linear" x1="45.585" y1="140.643" x2="304.528" y2="141.201" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#039BE5" />
                        <stop offset="1" stopColor="#75D2FF" />
                    </linearGradient>
                    <clipPath id="useCaseTimeCommitment0">
                        <rect y="0.852295" width="350" height="415" rx="30" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default UseCaseTimeCommitmentDesktop;
